import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  //baseURL: "https://bcm-uks-partner-portal-development.azurewebsites.net/api",
});

export default api;
